import React from 'react';
import {isMobileOnly} from "react-device-detect";
import Moment from "react-moment";
import {TFunction} from "i18next";
import axios from "axios";
import "../c41_avvisi/c41_avvisi.scss";
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";


const DEFAULT_CARD_COLOR = "#000000";

interface C68AvvisiDipartimentiCardData {
    title: string;
    category?: string;
    date?: string;
    link_title: string;
    link_url: string;
    color?: string;
}

interface C68AvvisiDipartimentiData {
    cards: C68AvvisiDipartimentiCardData[];
    loadmore_label: string;
    next_page?: string;
}

/**
 * Component 68 loads the announcements from the departments sites
 */
class C68AvvisiDipartimenti extends DoubleTemplateComponent<C68AvvisiDipartimentiData> {

    constructor(props: any) {
        super(props);

        this.requireInternationalization = true;
    }


    showMore(nextPage: string) {

        axios.get(nextPage).then(res => {
            let cards = this.state.data.cards.concat(res.data.cards);

            this.setState({
                callMore: true,
                data: {...this.state.data, ...{cards: cards, next_page: res.data.next_page}}
            });
        });
    };


    internationalComponentRender(data: C68AvvisiDipartimentiData, t: TFunction) {

        return (
            <div id={!isMobileOnly ? 'avvisi-grid' : 'avvisi-grid-mob'}>
                <div className="container">
                    <div className="row avvisi-card-row">
                        {(data.cards && data.cards.length > 0) ?
                                data.cards.map((card: C68AvvisiDipartimentiCardData, index: number) => {

                                let cardStyle = {
                                    color: DEFAULT_CARD_COLOR
                                };

                                if (card.color) {
                                    cardStyle.color = card.color;
                                }

                                return (
                                    <div className="col-xl-4 col-md-6" key={index}>
                                        <div className="avvisi-card mx-auto">
                                            {card.category ?
                                                <div className="avvisi-card-category" style={cardStyle}>{card.category}</div>
                                                :
                                                <div className={'separator'} />
                                            }
                                            <div className="avvisi-card-title">{card.title}</div>
                                            {card.date &&
                                                <div className="avvisi-card-date"><Moment date={card.date} format="D MMMM YYYY" /></div>
                                            }
                                            <div className="avvisi-card-cta"><a href={card.link_url}>{card.link_title}</a></div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <p className={'not-found'}>{t("C41 grid no content")}</p>
                        }
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {data.next_page &&
                                    <button className="avvisi-carica-altro-btn" onClick={() => this.showMore(data.next_page!)}>
                                        {data.loadmore_label}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default C68AvvisiDipartimenti;
